import { createSlice } from '@metorial/microfrontend';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthLoginPage } from './pages/login';
import { AuthLogoutPage } from './pages/logout';

// Accounts come from Google Workspace, so there is nothing to sign up for.
let SignupRedirect = () => <Navigate to={`/auth/login${useLocation().search}`} replace />;

export let authSlice = createSlice([
  {
    path: '',
    children: [
      {
        path: 'login',
        element: <AuthLoginPage />
      },
      {
        path: 'signup',
        element: <SignupRedirect />
      },
      {
        path: 'logout',
        element: <AuthLogoutPage />
      }
    ]
  }
]);
